import axios from "axios";
export const state = {
    diagnosis_status: false,
    notes_save_status: false,
    radio_status: false,
    consultation_patients: [],
    radiology_patients: [],
    procedure_patients: [],
    antenatal_patients: [],
    dental_patients: [],
    patient_complaints: [],
    final_diagnosis: [],
    provisional_diagnosis: [],
    diagnosis_details: {},
    radiology_report: '',
};

export const getters = {
    DiagnosisStatus: state => state.diagnosis_status,
    NotesSaveStatus: state => state.notes_save_status,
    RadioStatus: state => state.radio_status,
    FetchedRadioReport: state => state.radiology_report,
    ConsultationPatients: state => state.consultation_patients.data,
    RadiologyPatients: state => state.radiology_patients,
    ProcedurePatients: state => state.procedure_patients.data,
    AntenatalPatients: state => state.antenatal_patients.data,
    DentalPatients: state => state.dental_patients.data,
    PatientCompalints: state => state.patient_complaints.data,
    DiagnosisDetails: state => state.diagnosis_details.data,
    FinalDiagnosis: state => state.final_diagnosis.data,
    ProvisionalDiagnosis: state => state.provisional_diagnosis.data,
};

export const mutations = {
    SET_DIAGNOSIS_STATUS(state, newValue) {
        state.diagnosis_status = newValue
    },
    SET_CONSULTATION_PATIENTS(state, newValue) {
        state.consultation_patients = newValue
    },
    SET_RADIOLOGY_PATIENTS(state, newValue) {
        state.radiology_patients = newValue
    },
    SET_PROCEDURE_PATIENTS(state, newValue) {
        state.procedure_patients = newValue
    },
    SET_ANTENATAL_PATIENTS(state, newValue) {
        state.antenatal_patients = newValue
    },
    SET_DENTAL_PATIENTS(state, newValue) {
        state.dental_patients = newValue
    },
    SET_NOTES_SAVE_STATUS(state, newValue) {
        state.notes_save_status = newValue
    },
    SET_RADIO_STATUS(state, newValue) {
        state.radio_status = newValue
    },
    SET_PATIENTS_COMPLAINTS(state, newValue) {
        state.patient_complaints = newValue
    },
    SET_DIAGNOSIS_DETAILS(state, newValue) {
        state.diagnosis_details = newValue
    },
    SET_FINAL_DIAGNOSIS(state, newValue) {
        state.final_diagnosis = newValue
    },
    SET_PROVISIONAL_DIAGNOSIS(state, newValue) {
        state.provisional_diagnosis = newValue
    },
    SET_RADIOLOGY_REPORT(state, newValue) {
        state.radiology_report = newValue
    },

    CLEAR_REVIOUS_DETAILS(state) {
        state.diagnosis_details = {
            "data": {
                "id": null,
                "visitDate": null,
                "temp": null,
                "pressure": null,
                "weight": null,
                "muac": null,
                "pulse": null,
                "nextOfKin": null,
                "nextOfKinPhone": null,
                "patient": {
                    "id": "",
                    "patientName": "",
                    "patientContact": "",
                    "patientEmail": null,
                    "patientCode": "",
                    "NIN": null,
                    "DOB": "",
                    "patientAddress": "",
                    "clinicId": null,
                    "gender": null,
                    "status": null,
                    "visits": null,
                    "dateCreated": null,
                    "dateUpdated": null
                },
                "labrequests": [],
                "completetests": [],
                "patientservices": [],
                "prescriptions": [],
                "clinicnotes": [],
                "age": null,
                "status": null,
            }
        }
    },
};
export const actions = {
    fetchConsultationPatients({ commit, dispatch }) {
        axios.get('consultation_patients').then(c_res => {
            commit('SET_CONSULTATION_PATIENTS', c_res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchRadiologyPatients({ commit }) {
        axios.get('radiology_patients').then(r_res => {
            commit('SET_RADIOLOGY_PATIENTS', r_res.data)
        })
    },
    fetchProcedurePatients({ commit }) {
        axios.get('procedure_patients').then(p_res => {
            commit('SET_PROCEDURE_PATIENTS', p_res.data)
        })
    },
    fetchAntenatalPatients({ commit }) {
        axios.get('antenatal_patients').then(a_res => {
            commit('SET_ANTENATAL_PATIENTS', a_res.data)
        })
    },
    fetchDentalPatients({ commit }) {
        axios.get('dental_patients').then(d_res => {
            commit('SET_DENTAL_PATIENTS', d_res.data)
        })
    },

    fetchDiagnosisDetails({ commit, dispatch }, visit_id) {
        commit('SET_DIAGNOSIS_STATUS', true)
        commit('CLEAR_REVIOUS_DETAILS')
        axios.get(`diagnosis_detail/${visit_id}`).then((d_res) => {
            commit('SET_DIAGNOSIS_DETAILS', d_res.data)
            commit('SET_DIAGNOSIS_STATUS', false)
        }).catch(() => {
            let message = { 'msg': "Error fetching patient details" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchDiagnosisDetailsNotes({ commit, dispatch }, visit_id) {
        axios.get(`diagnosis_detail/${visit_id}`).then((d_res) => {
            commit('SET_DIAGNOSIS_DETAILS', d_res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    saveClinicalNotes({ commit, dispatch }, payload) {
        commit('SET_NOTES_SAVE_STATUS', true)
        axios.post('diagnosis', payload).then(() => {

            commit('SET_NOTES_SAVE_STATUS', false)
            dispatch('fetchDiagnosisDetailsNotes', payload.visit_id)
            let message = { 'msg': "Patient Notes saved successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('SET_NOTES_SAVE_STATUS', false)
            let message = { 'msg': "Error saving patient notes" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchPatientsComplaints({ commit }) {
        axios.get('complaints').then(c_res => {
            commit('SET_PATIENTS_COMPLAINTS', c_res.data)
        })
    },
    fetchFinalDiagnosis({ commit }) {
        axios.get('finaldiagnosises').then(c_res => {
            commit('SET_FINAL_DIAGNOSIS', c_res.data)
        })
    },
    fetchProvisionalDiagnosis({ commit }) {
        axios.get('provisionaldiagnosis').then(c_res => {
            commit('SET_PROVISIONAL_DIAGNOSIS', c_res.data)
        })
    },

    addRadiologyResults({ commit, dispatch }, payload) {
        commit('SET_RADIO_STATUS', true)
        axios.post('radiology_save', payload).then(() => {
            commit('SET_RADIO_STATUS', false)
            dispatch('fetchRadiologyPatients')
            let message = { 'msg': "Radiology Notes saved successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_RADIO_STATUS', false)
            let message = { 'msg': "Error saving radiology notes" }
            dispatch('notification/error', message, { root: true })
        })
    },

    FetchRadioReport({ commit }, id) {
        axios.get(`radiology_report/${id}`).then(r_res => {
            commit('SET_RADIOLOGY_REPORT', r_res.data)
        })
    },

};